import { API_URL, getCachedSessionId } from 'src/services/common';
import { FetchCustomersResponseData } from './interfaces/fetchCustomers.interface';

import { api } from '../../../../util/axios-instance';

export const fetchCustomers = async (
  projectId: string
): Promise<FetchCustomersResponseData | undefined> => {
  const response = await api.get<FetchCustomersResponseData>(
    `${API_URL}/v1/project/${projectId}/provider/authentication/customers`,
    {
      headers: { 'x-session-id': getCachedSessionId() }
    }
  );
  return response.data;
};
